var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 13.6141C0.833333 14.5349 1.57917 15.2808 2.5 15.2808H9.16667C10.0875 15.2808 10.8333 14.5349 10.8333 13.6141V3.61409H0.833333V13.6141ZM11.6667 1.1141H8.75L7.91667 0.280762H3.75L2.91667 1.1141H0V2.78076H11.6667V1.1141Z",
    fill: "#989DA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.fe297418aec219eb88550c211ea9bfa5.svg";
export { ForwardRef as ReactComponent };